import React from 'react';
import Link from 'next/link';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import LinkComponent from '@glowforge/gf-styled/src/components/link';
import Markdown from '@glowforge/gf-styled/src/components/markdown';

const JobsList = ({ jobs, textStrings, className }) => {
  /* Extract the title and subTitle from the textStrings array */
  let mainTitle;
  let subTitle;

  textStrings.forEach((textObj) => {
    if (textObj?.fields?.id === 'jobs-current-openings-title') mainTitle = textObj.fields.text;
    if (textObj?.fields?.id === 'jobs-current-openings-subtext') subTitle = textObj.fields.text;
  });

  /*
    Jobs come in a flat array.
    We want to group them up by category and display them in alphabetical order.
    Because objects are unordered, we keep a separate array to iterate later.
  */
  const jobsByCategory = jobs.reduce((categories, job) => {
    const { title, slug } = job.fields;
    const category = job.fields.category?.fields?.title;

    // Some jobs do not have a category, so we shall ignore them for now.
    if (category) {
      if (categories[category]) {
        categories[category].push({ title, slug });
      } else {
        // Ignore eslint since we don't know the shape of our obj beforehand
        /* eslint-disable-next-line no-param-reassign */
        categories[category] = [{ title, slug }];
      }
    }
    return categories;
  }, {});

  // We could inline this in our return, but let's keep it more explicit.
  const categoryArray = Object.keys(jobsByCategory).sort();

  return (
    <div id='jobs-homes-openings' className={`JobsList ${className}`}>
      <h1 className='h2'>{mainTitle}</h1>
      <Markdown className='subTitle paragraph' source={subTitle} />
      <div className='listings'>
        {categoryArray.map((category) => (
          <div className='category' key={category}>
            <h3 className='h4'>{category}</h3>
            {jobsByCategory[category].map((job, i) => (
              // There can be duplicate slugs in same category.
              /* eslint-disable-next-line react/no-array-index-key */
              <Link key={`${i}-${job.slug}`} href={`/jobs/${job.slug}`} passHref legacyBehavior>
                <LinkComponent variant='body'>{job.title}</LinkComponent>
              </Link>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

JobsList.propTypes = {
  jobs: PropTypes.arrayOf(PropTypes.shape({})),
  textStrings: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  className: PropTypes.string,
};

JobsList.defaultProps = {
  jobs: [],
  className: '',
};

export default styled(JobsList)`
.listings {
  columns: 1;
  padding-left: 1rem;

  @media (min-width: 960px) {
    columns: 2;
    padding-left: revert;
  }
}

.category {
  break-inside: avoid;

  h3 {
    padding: 1rem 0 0.75rem 0;
  }

  a {
    display: block;
    margin-left: 1rem;
    padding: 0.25rem 0;
    width: fit-content;
  }
}
`;
